import Component from '../abstracts/Component';

export default class CartLayerComponent extends Component {

  get SELECTORS() {
    return {
      main: '.l-quick-cart',
      content: '[data-items-container]',
      items: '[data-mc-item]',
      checkoutBlock: '[data-mc-checkout]',
      dataQty: '[data-mcqty]',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.items = this.$component.querySelectorAll(this.SELECTORS.items);
    this.itemsContainer = this.$component.querySelector(this.SELECTORS.content);
    this.checkoutBlock = this.$component.querySelector(this.SELECTORS.checkoutBlock);
  }
  setDataQty(qty) {
    let dataAttributes = document.querySelectorAll(this.SELECTORS.dataQty);
    for (let dataAttr of dataAttributes) {
      //not dataAttr.dataset.mcqty = qty; for IE11
      $(dataAttr).attr("data-mcqty",qty);
    }
  }

  counterList() {
    let itemsEl = this.$component.querySelectorAll(this.SELECTORS.items);
    this.setDataQty(itemsEl.length);
    if (itemsEl.length > 0) {
      this.toggleEmpty(true);
      this.moduleLoader.loadSimpleBarAndExecute(
        module => {
          this.initSimpleBar(module.default);
        },
        error => {
          console.log('failed to load SimpleBar ', error.stack);
        }
      );
    } else if (itemsEl.length == 0) {
      this.toggleEmpty(false);
    }
  }
  toggleEmpty(bool) {
    // new simple code
    if (bool) {
      this.$component.classList.remove('empty');
    } else {
      this.$component.classList.add('empty');
    }
  }
  initSimpleBar(SimpleBar) {
    let itemsContainer = this.$component.querySelector(this.SELECTORS.content);
    new SimpleBar(itemsContainer);
  }

  bindEvents() {
    this.$on(this.$customEvents.MINICART_EVENTS.update, (e) => {
      this.counterList();
    });
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
    //
    this.counterList();
  }
}
